// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//引入element-ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

window.baseUrl = 'http://dyxy.kaopu58.com';
window.config = {
  news: '/api/index/news', //1.首页数据
  newsDetails: '/api/index/newsDetails', //2.z新闻详情
  system: '/api/index/system', //3.底部数据
  moreNews: '/api/Index/moreNews', // 4.更多新闻列表
  company: '/api/Index/company', //5.公司介绍与领导人致辞
  honorList: '/api/Index/honorList', //6.企业荣誉
  Mass: '/api/Index/Mass', //7.主营业务
  laws: '/api/Index/laws', //8.法规文件
  recruitment: '/api/Index/recruitment', //9.人才招聘
  MassInfo:'/api/index/MassInfo',//党群工作详情页
  smsSend: '/api/Registere/smsSend', //10.获取手机验证码
  registered: '/api/Registere/registered', //11.提交注册
  login: '/api/Login/login', //13.用户登录
  search: '/api/Index/search', //12 搜索列表
  message: '/api/Message/message', //14.提交留言
  businessShow: '/api/index/businessShow', //15 业务展示列表
  smsSendForget: '/api/Registere/smsSendForget', //16 发送忘记密码短信
  forgetPwd: '/api/Registere/forgetPwd', //17 忘记密码修改
}

import axios from 'axios'
import qs from 'qs'
Vue.prototype.$qs = qs
Vue.prototype.$http = axios;


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js